import * as React from "react";
import { formatDateTime } from "../../CommonFunctions";
import {ProductsEnum, resourcesHelper} from "@falcon/services";

interface IProps {
    product: string;
    productWording: React.ReactNode;
    endDate: string;
}

export class RenewalDeclinedBanner extends React.Component<IProps> {
    constructor(props: any) {
        super(props);
    }

    public render(): React.ReactNode {
        const productWording: string = this.props.product === ProductsEnum.WOLF_MOTOR ?
            `${resourcesHelper.PRODUCT} Car Insurance policy` : `${resourcesHelper.PRODUCT} Home Insurance policy`;
        const product: string = this.props.product === ProductsEnum.WOLF_MOTOR ? "car" : "home";

        return (
            <div className="banner pending-renewal-banner banner-warn">
                <div className="banner-text">
                    <p>
                        Heads up - your {productWording} for {this.props.productWording} <strong>ends on {formatDateTime(this.props.endDate)}.</strong>{' '}
                        Until then you are still covered.
                    </p>
                    <p className="font-weight-bold">Make sure you arrange alternative cover for your {product}.</p>
                </div>
            </div>
        );
    }
}
